import Http from '../api/http/';

export default class ReportExperience extends Http {
  constructor() {
    super();
  }

  /***********在线报告用户体验描述管理***************/
  /**
   * 导出word
   * @param {string} reportTemplateId -  在线报告模板id
   * @param {string} reportExperienceId -  用户体验描述id
   */
  reportExperience_exprotWord() {
    return super.get('reportExperience/exprotWord', ...arguments);
  }

  // 删除报告批注
  reportExperience_clearPostil() {
    return super.post('reportExperience/clearPostil', ...arguments);
  }
  /**
   * 获取报告树结构
   * @param {String} reportExperienceId -  reportExperienceId
   */
  reportExperience_getReportExperience() {
    return super.post('reportExperience/getReportExperience', ...arguments);
  }
  /**
   * 分享新在线报告（免登录）
   * @param {string} reportExperienceId -  用户体验描述id
   */

  reportExperience_shareTemplateExperience() {
    return super.post('reportExperience/shareTemplateExperience', ...arguments);
  }
  /**
   * 保存报告树结构或者数组
   * @param {Array} reportExperienceContentVo -  reportExperienceContentVo
   */
  reportExperience_saveReportExperienceContent() {
    return super.post('reportExperience/saveReportExperienceContent', ...arguments, {});
  }
  /**
   * 保存报告阶段内容
   * @returns
   */
  reportExperience_saveReportExperiencePhaseContent() {
    return super.post('reportExperience/saveReportExperiencePhaseContent', ...arguments);
  }
  /**
   * 获取报告树结构或者数组
   * @param {string} reportExperienceId -  用户体验描述id
   * @param {integer} isShowAll -  是否显示所有关联题1是0否
   */
  reportExperience_getReportExperienceContent() {
    return super.post('reportExperience/getReportExperienceContent', ...arguments);
  }
  /**
   * 模板预填写内容
   * @returns
   */
  reportExperience_preGetReportExperience() {
    return super.post('reportExperience/preGetReportExperience', ...arguments);
  }
  /**
   * 模板预填写保存内容
   * @returns
   */
  reportExperience_preSaveReportExperience() {
    return super.post('reportExperience/preSaveReportExperience', ...arguments);
  }
  /**
   * 获取历史报告
   * @param {string} historyReportId -  历史报告id
   */
  reportExperience_getHistoryReportExperience() {
    return super.post('reportExperience/getHistoryReportExperience', ...arguments);
  }

  /**
   * 验证现代加急工单
   * @param {string} reportLogId - 报告日志id
   */
  reportExperience_validXdHastenWorkByReportId() {
    return super.post('reportExperience/validXdHastenWorkByReportId', ...arguments);
  }
  //报告操作记录导出
  reportExperience_getReportOperateRecordList() {
    return super.post('reportExperience/getReportOperateRecordList', ...arguments);
  }
}
